import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from '@app/feature/store-editor/components/layout/layout.component';


const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    data: {
      viewOnly: false
    }
  },
  {
    path: 'view',
    component: LayoutComponent,
    data: {
      viewOnly: true
    }
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StoreEditorRouting {

}

